export default "__VITE_PUBLIC_ASSET__8fcf3db8__"